<template>
  <b-icon v-bind="$attrs"/>
</template>

<script>
export default {
  name: 'qd-icon',
};
</script>
